import ng from 'angular';

export class MeurhModalEstabilidadeController implements ng.IController {

    static $inject = [
        'tipoEstabilidade',
        '$uibModalInstance'
    ];

    constructor(
        public tipoEstabilidade: string,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService
    ) { }

    public close() {
        this.$uibModalInstance.dismiss();
    }
}
